import { Badge, ThemeIcon } from '@mantine/core'
import { IconCheck, IconClock, IconX } from '@tabler/icons'

export const CONTRACT_PAYMENT_STATUS = {
  pending: { icon: <IconClock />, label: 'Pendente', color: 'yellow' },
  success: { icon: <IconCheck />, label: 'Pago', color: 'green' },
  not_authorized: { icon: <IconX />, label: 'Não autorizado', color: 'red' },
  error: { icon: <IconX />, label: 'Erro', color: 'red' }
}

type OrderKeyType = keyof typeof CONTRACT_PAYMENT_STATUS

interface SingleProps {
  status: OrderKeyType
  showIcon?: boolean
}

function ContractPayment({ status, showIcon = true, ...otherProps }: SingleProps) {
  if (!status) return null

  return (
    <Badge
      color={CONTRACT_PAYMENT_STATUS[status]?.color}
      size="lg"
      px="xs"
      leftSection={
        showIcon && (
          <ThemeIcon
            color={CONTRACT_PAYMENT_STATUS[status]?.color}
            variant="light"
            size="sm"
            display="flex">
            {CONTRACT_PAYMENT_STATUS[status]?.icon}
          </ThemeIcon>
        )
      }
      {...otherProps}>
      {CONTRACT_PAYMENT_STATUS[status]?.label}
    </Badge>
  )
}

export default ContractPayment
